import UI from "@mile-meeting/mile-ui";
import { Container } from "./MeetingRoomRestrictionRequestPage.styles";
import RequestTable from "./components/RequestTable";
import { useEffect, useState } from "react";
import RequestDetailModal from "./components/RequestDetailModal";
import RequestCancelConfirmModal from "./components/RequestCancelConfirmModal";
import RequestRestrictionModal from "./components/RequestRestrictionModal";
import { useToast } from "hook/useToast";
import {
  createRestrictRequest,
  deleteRestrictRequest,
  getMyRestrictRequestList,
  TRestrictRequest,
} from "apis/meetings/block-request";

const MeetingRoomRestrictionRequestPage = () => {
  const [restrictDataList, setRestrictDataList] = useState<TRestrictRequest[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<TRestrictRequest>();
  const [openRequestDetailModal, setOpenRequestDetailModal] = useState<boolean>(false);
  const [openRequestCancelConfirmModal, setOpenRequestCancelConfirmModal] = useState<boolean>(false);
  const [openRequestRestrictionModal, setOpenRequestRestrictionModal] = useState<boolean>(false);
  const { showToast } = useToast();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);

  const fetchRestrictRequestList = async (nowPage: number) => {
    const res = await getMyRestrictRequestList(nowPage);
    // 만약 1페이지가 아니고, 데이터 리스트가 없다면 nowPage 1로 재조회

    if (res.data?.blockRequests.length === 0 && nowPage !== 1) {
      const res = await getMyRestrictRequestList(nowPage - 1);
      setRestrictDataList(res.data?.blockRequests ?? []);
      setTotalPage(res.data?.totalPageNumber ?? 1);
      setCurrentPage(res.data?.nowPageNumber ?? 1);
      return;
    } else {
      setRestrictDataList(res.data?.blockRequests ?? []);
      setTotalPage(res.data?.totalPageNumber ?? 1);
      setCurrentPage(res.data?.nowPageNumber ?? 1);
    }
  };

  useEffect(() => {
    fetchRestrictRequestList(1);
  }, []);

  return (
    <Container style={{ minWidth: 1140, boxSizing: "border-box", position: "relative" }}>
      <div
        style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between", paddingRight: 20 }}
      >
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{ padding: "24px 20px" }}
        >
          회의실 예약 제한 요청
        </UI.Typography>
        <UI.Button
          title="예약 제한 요청하기"
          prefixIcon={"addCircle"}
          showPrefixIcon
          onClick={() => setOpenRequestRestrictionModal(true)}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", padding: "0 20px", gap: 36 }}>
        <RequestTable
          data={restrictDataList}
          onOpenDetailModal={(item: TRestrictRequest) => {
            setSelectedRequest(item);
            setOpenRequestDetailModal(true);
          }}
          onCancel={(item: TRestrictRequest) => {
            setSelectedRequest(item);
            setOpenRequestCancelConfirmModal(true);
          }}
        />
        {restrictDataList.length !== 0 && (
          <UI.Pagination
            pageCount={totalPage}
            currentPage={currentPage}
            onChange={(page) => {
              fetchRestrictRequestList(page);
            }}
          />
        )}
      </div>

      <RequestDetailModal
        modalIsOpen={openRequestDetailModal}
        closeModal={() => {
          setOpenRequestDetailModal(false);
        }}
        onCancel={() => {
          setOpenRequestCancelConfirmModal(true);
        }}
        data={selectedRequest}
      />
      <RequestCancelConfirmModal
        modalIsOpen={openRequestCancelConfirmModal}
        closeModal={() => setOpenRequestCancelConfirmModal(false)}
        meetingRoomName={selectedRequest?.meetingRoom.name ?? ""}
        onConfirm={async () => {
          if (selectedRequest) {
            const res = await deleteRestrictRequest(selectedRequest.id);
            if (res.success) {
              showToast(`“${selectedRequest.meetingRoom.name}” 회의실의 예약 제한 요청을 취소했습니다.`, "success");
              fetchRestrictRequestList(currentPage);
              setOpenRequestCancelConfirmModal(false);
              setOpenRequestDetailModal(false);
            } else {
              showToast("회의실 예약 제한 요청 취소중 오류가 발생했습니다. 다시 시도해 주세요.", "error");
            }
          }
        }}
      />
      <RequestRestrictionModal
        modalIsOpen={openRequestRestrictionModal}
        closeModal={() => setOpenRequestRestrictionModal(false)}
        onRegister={async (meetingRoom, meetingTitle, startTime, endTime, reason) => {
          const res = await createRestrictRequest(meetingRoom.id, meetingTitle, startTime, endTime, reason);
          if (res.success) {
            showToast(`"${meetingRoom.name}"회의실의 예약 제한 요청이 완료되었습니다.`, "success");
            setOpenRequestCancelConfirmModal(false);
            fetchRestrictRequestList(currentPage);
          } else {
            showToast("회의실 예약 제한 요청에 실패했습니다. 다시 시도해주세요.", "error");
          }
          setOpenRequestRestrictionModal(false);
        }}
      />
    </Container>
  );
};

export default MeetingRoomRestrictionRequestPage;
